// Klimaat-projectie per concelho voor 2050 (IPCC SSP2-4.5).
// Voor sunshine: zuid wordt iets droger maar krijgt MEER zon (minder bewolking).
// Noord (Costa Verde): mogelijk iets MINDER zon door warmere oceaan-feedback.

export const CLIMATE_2050 = {
  // Alentejo Coast
  "odemira":              { heat_days_35: 38, summer_max_p95: 39, annual_rainfall_mm: 530, annual_sunshine_h: 2960, trend: "warmer-drier" },
  "grandola":             { heat_days_35: 44, summer_max_p95: 40, annual_rainfall_mm: 530, annual_sunshine_h: 2940, trend: "warmer-drier" },
  "santiago-do-cacem":    { heat_days_35: 40, summer_max_p95: 39, annual_rainfall_mm: 540, annual_sunshine_h: 2930, trend: "warmer-drier" },
  "sines":                { heat_days_35: 18, summer_max_p95: 35, annual_rainfall_mm: 460, annual_sunshine_h: 2830, trend: "moderate" },

  // Algarve
  "aljezur":              { heat_days_35: 26, summer_max_p95: 37, annual_rainfall_mm: 510, annual_sunshine_h: 2920, trend: "warmer-drier" },
  "vila-do-bispo":        { heat_days_35: 18, summer_max_p95: 35, annual_rainfall_mm: 470, annual_sunshine_h: 2900, trend: "moderate" },
  "tavira":               { heat_days_35: 38, summer_max_p95: 38, annual_rainfall_mm: 420, annual_sunshine_h: 3110, trend: "warmer-drier" },
  "olhao":                { heat_days_35: 32, summer_max_p95: 37, annual_rainfall_mm: 390, annual_sunshine_h: 3140, trend: "warmer-drier" },

  // Silver Coast
  "caldas-da-rainha":     { heat_days_35: 24, summer_max_p95: 36, annual_rainfall_mm: 660, annual_sunshine_h: 2740, trend: "moderate" },
  "obidos":               { heat_days_35: 26, summer_max_p95: 36, annual_rainfall_mm: 660, annual_sunshine_h: 2750, trend: "moderate" },
  "alcobaca":             { heat_days_35: 34, summer_max_p95: 38, annual_rainfall_mm: 660, annual_sunshine_h: 2750, trend: "warmer" },
  "peniche":              { heat_days_35: 10, summer_max_p95: 31, annual_rainfall_mm: 480, annual_sunshine_h: 2770, trend: "stable" },
  "mafra":                { heat_days_35: 16, summer_max_p95: 34, annual_rainfall_mm: 720, annual_sunshine_h: 2730, trend: "moderate" },
  "lourinha":             { heat_days_35: 14, summer_max_p95: 33, annual_rainfall_mm: 660, annual_sunshine_h: 2740, trend: "moderate" },
  "nazare":               { heat_days_35: 14, summer_max_p95: 33, annual_rainfall_mm: 660, annual_sunshine_h: 2790, trend: "moderate" },

  // Setúbal
  "sesimbra":             { heat_days_35: 28, summer_max_p95: 37, annual_rainfall_mm: 600, annual_sunshine_h: 2900, trend: "warmer" },
  "setubal":              { heat_days_35: 52, summer_max_p95: 41, annual_rainfall_mm: 560, annual_sunshine_h: 2900, trend: "much-warmer" },

  // Sintra
  "sintra":               { heat_days_35: 10, summer_max_p95: 33, annual_rainfall_mm: 900, annual_sunshine_h: 2420, trend: "stable" },

  // Costa Verde
  "caminha":              { heat_days_35: 6, summer_max_p95: 30, annual_rainfall_mm: 1320, annual_sunshine_h: 2330, trend: "stable" },
  "viana-do-castelo":     { heat_days_35: 8, summer_max_p95: 31, annual_rainfall_mm: 1320, annual_sunshine_h: 2330, trend: "stable" },
  "esposende":            { heat_days_35: 10, summer_max_p95: 32, annual_rainfall_mm: 1320, annual_sunshine_h: 2370, trend: "stable" },

  // Aveiro Coast
  "aveiro":               { heat_days_35: 14, summer_max_p95: 33, annual_rainfall_mm: 840, annual_sunshine_h: 2510, trend: "moderate" },
  "ilhavo":               { heat_days_35: 12, summer_max_p95: 32, annual_rainfall_mm: 840, annual_sunshine_h: 2510, trend: "stable" },
};

// Zwolle (KNMI Heino) — huidige normalen + 2050 projecties (KNMI'23 scenarios)
// SSP2-4.5 vergelijkbaar middle-of-the-road scenario voor NL.
export const ZWOLLE_BASELINE = {
  current: {
    heat_days_35: 0,           // bijna nooit
    summer_max_p95: 28,         // ~28°C piek
    annual_rainfall_mm: 827,
    annual_sunshine_h: 1676,
  },
  projected_2050: {
    heat_days_35: 6,            // verwachting +5-7 dagen
    summer_max_p95: 32,         // +3-4°C piek
    annual_rainfall_mm: 890,    // +5-10% naar 880-900
    annual_sunshine_h: 1700,    // marginaal hoger
  },
};

const TREND_LABELS = {
  "stable":       { label: "Stabiel",         emoji: "🟢", note: "Weinig verandering verwacht — Atlantische moderatie houdt klimaat in toom." },
  "moderate":     { label: "Gematigd warmer", emoji: "🟢", note: "Lichte opwarming maar geen drastische verandering. Water-positie OK." },
  "warmer":       { label: "Warmer",          emoji: "🟡", note: "Merkbaar warmer en iets droger. Manageable met goede schaduw + watermanagement." },
  "warmer-drier": { label: "Warmer + droger", emoji: "🟠", note: "Meer hittedagen + minder regen. Irrigatie-strategie nodig voor permaculture/farm." },
  "much-warmer":  { label: "Sterk verergerend", emoji: "🔴", note: "Significant warmere zomers + droogte-stress. Risicovoller voor zelfvoorziening + comfort." },
};

export function climate2050(slug) {
  return CLIMATE_2050[slug] || null;
}

export function trendLabel(trend) {
  return TREND_LABELS[trend] || TREND_LABELS.moderate;
}

export function futureProofScore(currentClimate, projected2050) {
  if (!currentClimate || !projected2050) return null;
  const heatDelta = (projected2050.heat_days_35 || 0) - (currentClimate.heat_days_35 || 0);
  const rainDelta = (currentClimate.annual_rainfall_mm || 0) - (projected2050.annual_rainfall_mm || 0);
  if (heatDelta <= 5 && rainDelta <= 50) return 5;
  if (heatDelta <= 10 && rainDelta <= 100) return 4;
  if (heatDelta <= 20 && rainDelta <= 150) return 3;
  if (heatDelta <= 30 && rainDelta <= 200) return 2;
  return 1;
}
